"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyOne = void 0;
/**
 * This entity represents the output of a delete impulse
 */
var KeyOne = /** @class */ (function (_super) {
    __extends(KeyOne, _super);
    function KeyOne() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._typeName = "KeyOne";
        _this.identityId = function () {
            _this.push(function (_) { return "identityId"; });
        };
        _this.reference = function () {
            _this.push(function (_) { return "reference"; });
        };
        _this.render = function (registry) { return _this.map(function (e) { return e(registry); }).join(" "); };
        return _this;
    }
    return KeyOne;
}(Array));
exports.KeyOne = KeyOne;
//# sourceMappingURL=KeyOne.js.map